import type { ComponentProps } from 'react';
import type { CinematicOverrides } from '../../../../renderer/src/cinematic-sequence';
import { TimelineWaypoints } from './TimelineWaypoints';
import { cinematicPropertyTimeline } from '../../domain/cinematic-property-timeline';

export const SCENE_TRACK_LABELS = {
  mapStyle: 'Map style', cameraStyle: 'Camera Platform', cameraDistance: 'Distance',
  cameraGimbal: 'Gimbal', cameraAngle: 'Angle', cameraZoom: 'Map zoom',
  depthOfField: 'DOF', presentationAppearance: 'Presentation appearance',
} satisfies Record<keyof CinematicOverrides, string>;

/** Each lane selects and edits only its own property, including legacy bundled keys. */
export function TimelineSceneTracks(props: Omit<ComponentProps<typeof TimelineWaypoints>, 'onMove' | 'onTransition'> & {
  selectedProperty?: keyof CinematicOverrides | undefined;
  previewProperty?: keyof CinematicOverrides | undefined;
  onMove: (id: string, seconds: number, property?: keyof CinematicOverrides) => void;
  onTransition?: ((id: string, duration: number, property?: keyof CinematicOverrides) => void) | undefined;
  onPropertySelect?: ((id: string, property: keyof CinematicOverrides) => void) | undefined;
}) {
  return <>{(Object.keys(SCENE_TRACK_LABELS) as (keyof CinematicOverrides)[]).map(property => {
    const waypoints = cinematicPropertyTimeline(props.waypoints, property, props.duration);
    return waypoints.length ? <TimelineWaypoints {...props} key={property} property={property} label={SCENE_TRACK_LABELS[property]} waypoints={waypoints}
      selected={props.selectedProperty === property ? props.selected : null}
      preview={props.previewProperty === property ? props.preview : undefined}
      onMove={(id, seconds) => props.onMove(id, seconds, property)} onTransition={(id, duration) => props.onTransition?.(id, duration, property)}
      deletionLabel={`${SCENE_TRACK_LABELS[property]} key`} onDelete={id => props.onDelete(id, property)}
      onSelect={id => props.onPropertySelect ? props.onPropertySelect(id, property) : props.onSelect(id)} /> : null;
  })}</>;
}
